import axios from 'axios'
import router from '@/router'
import Swal from "sweetalert2";

// 🧠 cache de requisições GET
const cache = new Map();
const CACHE_DURATION_MS = 5 * 60 * 1000; // 5 minutos
const CACHE_DURATION_MS_MIN = 20 * 1000; // 20 segundos

const api = axios.create({
  baseURL: process.env.VUE_APP_TITLE,
  headers: {
    "Content-Type": "application/json"
  }
});

// Interceptor de requisição
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  const rotasLiberadas = ['/consulta', '/register', '/login', '/declaracao/assinaturas', '/declaracao/assinar'];
  const rotasSemCache = ['/register', '/login', '/excluir', '/declaracao/assinante', '/produto', '/suitability', '/produtos'];
  const rotasCacheReduzido = ['/declaracao/cliente'];
  const url = config.url?.toLowerCase() || '';
  const isRotaLiberada = rotasLiberadas.some(nome => url.includes(`${nome.toLowerCase()}`));
  const isRotaSemCache = rotasSemCache.some(nome => url.includes(`${nome.toLowerCase()}`));
  const isRotaCacheReduzido = rotasCacheReduzido.some(nome => url.includes(`${nome.toLowerCase()}`));


  // 🧠 Caching de GET
  if (config.method === 'get' && !isRotaSemCache && !isRotaCacheReduzido) {
    const cached = cache.get(config.url);
    if ((cached && Date.now() - cached.timestamp < CACHE_DURATION_MS )
    || (isRotaCacheReduzido && cached && Date.now() - cached.timestamp < CACHE_DURATION_MS_MIN)) {
      return Promise.reject({ __fromCache: true, data: cached.response });
    } else if (cached) {
      cache.delete(config.url); 
    }
  }

  if(config.method === 'post'){
    // eslint-disable-next-line no-debugger
    debugger
    const urlParts = config.url.split('/').filter(p => p); // remove strings vazias
    const secondWord = urlParts[1];

    const keys = Array.from(cache.keys());

    for (const key of keys) {
      if (key.startsWith(config.url) || key.includes(secondWord)) {
        cache.delete(key);
      }
    }
  }

  if (isRotaLiberada) {
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  }

  if (!token) {
    return Promise.reject({
      config,
      response: {
        status: 401,
        data: {
          message: 'Token ausente. A requisição foi bloqueada.'
        }
      },
      isTokenMissing: true
    });
  }

  config.headers.Authorization = `Bearer ${token}`;
  return config;
}, error => Promise.reject(error));

// Interceptor de resposta
api.interceptors.response.use(response => {
  // 🧠 Armazena no cache se for GET
  if (response.config.method === 'get') {
    cache.set(response.config.url, {
      response,
      timestamp: Date.now()
    });
  }

  return response;
}, error => {
  // 🧠 Se veio do cache, retorna como resposta resolvida
  if (error.__fromCache) {
    return Promise.resolve(error.data);
  }

  if (error.isTokenMissing) {
    return new Promise(() => {}); // ignora erro de token ausente
  }

  // eslint-disable-next-line no-debugger
  debugger

  const url = error.config?.url?.toLowerCase() || '';
  const rotasSemTratamentoDeErroGenerico = ['/register', '/login', '/declaracoes'];
  const isRotasSemTratamentoDeErroGenerico = rotasSemTratamentoDeErroGenerico.some(nome => url.includes(`${nome.toLowerCase()}`));


  if (error.response && error.response.status === 401) {
    if (router.currentRoute.name !== 'UserLogin') {
      Swal.fire({
        icon: 'warning',
        title: 'Sessão expirada',
        text: 'Faça o login novamente.'
      });

      // Evita erro de this.$store
      localStorage.removeItem('token'); // ou dispatch para Vuex se quiser

      router.push({ name: 'UserLogin' });
    }
  } else if (error.response && error.response.status === 400 && !isRotasSemTratamentoDeErroGenerico) {
    Swal.fire({
      icon: 'warning',
      title: 'Ação não realizada',
      text: error.response.data.data[0] ?? 'O servidor não retornou a requisição. Tente novamente.'
    });
  }

  return Promise.reject(error);
});

export default api;
